var _circle, _path, _circle2, _ellipse, _ellipse2, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    transform: "rotate(90 26 26)",
    fill: "#8A7DE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4834 11.962C31.4511 8.22944 29.0362 12.0535 28.4577 14.4321C31.2776 18.5488 37.3022 31.9436 38.7067 33.5822C40.1709 35.2904 40.6228 35.8092 41.635 36.9985C41.288 34.5833 41.4 27.3312 41.2554 24.8612C40.5613 18.2743 39.3032 14.7064 36.4834 11.962Z",
    fill: "#674E74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5534,
    cy: 26.9986,
    r: 14.1534,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.137,
    cy: 29.9265,
    rx: 0.976096,
    ry: 1.46414,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9459,
    cy: 29.9265,
    rx: 0.976096,
    ry: 1.46414,
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9936 33.3433H22.8452C22.8452 34.3194 23.5773 35.0514 25.0414 35.0514C26.4218 35.0514 26.9123 33.994 26.9936 33.3433Z",
    fill: "#F09387"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8085 12.845C13.9779 13.0584 10.7725 21.6298 10.4 26.0223H20.4564L20.8288 21.5043H22.3187L22.6911 25.6458H26.7882L27.1606 21.5043H28.6505L29.0229 25.6458H38.7068C38.2188 21.1417 35.0465 12.601 23.8085 12.845Z",
    fill: "#674E74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3761 21.6501C10.7905 22.9952 10.4814 25.1248 10.4 26.0214C15.7686 26.0214 27.7257 26.2604 38.7068 26.0165C38.7068 24.4026 38.0561 22.4088 37.7307 21.6242C26.5056 21.3802 16.5006 21.3802 11.3761 21.6501Z",
    fill: "#D3CDFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.1497,
    y: 16.4609,
    width: 0.800168,
    height: 6.14048,
    transform: "rotate(122.054 34.1497 16.4609)",
    fill: "#D3CDFB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile6);
export default __webpack_public_path__ + "static/media/img_profile_6.d5508a565b304ad6ffc2ebd6509f973f.svg";
export { ForwardRef as ReactComponent };